import { render, staticRenderFns } from "./SpecificationItem.vue?vue&type=template&id=b047d4b8"
import script from "./SpecificationItem.vue?vue&type=script&lang=js"
export * from "./SpecificationItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports